import { render, staticRenderFns } from "./RemindersQuickAdd.vue?vue&type=template&id=275ca51b&scoped=true&"
import script from "./RemindersQuickAdd.vue?vue&type=script&lang=js&"
export * from "./RemindersQuickAdd.vue?vue&type=script&lang=js&"
import style0 from "./RemindersQuickAdd.vue?vue&type=style&index=0&id=275ca51b&scoped=true&lang=css&"
import style1 from "./RemindersQuickAdd.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ca51b",
  null
  
)

export default component.exports